// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '63875cb3d6fc21b258e2995970e01d8ccb1dbab5';
export const BUILD_NUMBER = '191';
export const BUILD_TIMESTAMP = '2026-07-09T05:50:06.542Z';
